export default __webpack_public_path__ + "static/manage-access-cf96bd3b2d34494681465c3ed9d1566a.png";